import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper';
import ProductListMobile from '../components_mobile/pages/ProductList';
import ProductListDesktop from '../components_desktop/pages/ProductList';
import { apiGet } from '../modules/api';
import { productMode } from '../helpers/productListModes';
import metadata from '../helpers/metadataHelper';
import { ReactPixel } from '../helpers';
import { setCountryCode } from '../modules/manageCountryCode';

class ProductListComponent extends Component {
  render() {
    const allProps = { mode: productMode, ...this.props };
    return (
      <AppWrapper
        desktopComp={<ProductListDesktop {...allProps} />}
        mobileComp={<ProductListMobile {...allProps} />}
        metadata={metadata.productList}
      />
    );
  }

  componentDidMount() {
    ReactPixel.track('ViewContent', this.props.fbPixelSearchDetailData);
  }

  static async getInitialProps({ store, req, res, query, asPath }) {
    // avoid req undefined on back button
    if (!req) {
      return;
    }

    /* dispatch(setCountryCode(req.params.countryCode)); */

    const { first_call } = query;
    return store.dispatch(
      apiGet(`api/search/${asPath.replace(/\/\S{2}/, '')}`, req, res, {
        params: { first_call },
      }),
    );
  }
}

const mapStateToProps = ({
  api: {
    filterSettings,
    fbPixelSearchDetailData,
    freeShipping,
    brandDescription,
    brandName,
    closeSizeGuide,
    currencySymbol,
    categoryName,
    categoryPath,
    categoryUrl,
    onSale,
    openSizeGuide,
    products,
    page,
    sizes,
    query,
    s3BasePath,
    sizeGuideVisibility,
    total,
  },
}) => ({
  filterSettings,
  fbPixelSearchDetailData,
  freeShipping,
  brandDescription,
  brandName,
  closeSizeGuide,
  currencySymbol,
  categoryName,
  categoryPath,
  categoryUrl,
  onSale,
  openSizeGuide,
  page,
  products,
  sizes,
  query,
  s3BasePath,
  sizeGuideVisibility,
  total,
});

const ProductList = connect(mapStateToProps)(ProductListComponent);
export default ProductList;
